/* eslint-disable */
import { produce } from "immer";
import {
  DRAWDOWN_DATA_FETCH_FAILURE,
  DRAWDOWN_DATA_FETCH_SUCCESS,
  DRAWDOWN_DATA_FETCH_START,
} from "../actions/types";

const drawdown = (
  state = {
    drawFetching: false,
    drawData: [],
    drawError: null,
  },
  action,
) => {
  switch (action.type) {
    case DRAWDOWN_DATA_FETCH_START:
      return produce(state, (draft) => {
        draft.drawFetching = true;
      });
    case DRAWDOWN_DATA_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.drawFetching = true;
        draft.drawData = action.data;
        draft.drawFetching = false;
      });
    case DRAWDOWN_DATA_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.drawFetching = false;
        draft.drawError = action.error;
      });
    default:
      return state;
  }
};

export default drawdown;
